import { memo } from 'react';
import VisualizationViolinDiagramContainer from './VisualizationViolinDiagramContainer';

interface ViolinPlotsSectionProps {
    uploadSessionId: string;
}

const ViolinPlotsSection = memo(({
    uploadSessionId
}: ViolinPlotsSectionProps) => {
    return (
        <div className="mt-8">
            <VisualizationViolinDiagramContainer sessionId={uploadSessionId} />
        </div>
    );
});

ViolinPlotsSection.displayName = 'ViolinPlotsSection';

export default ViolinPlotsSection;
